module.exports = __webpack_public_path__ + "static/media/private_placement.51502ed8.png";